import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { ReviewDriverBreakEntity } from '../../domain/entities/ReviewDriverBreakEntity'

export class ReviewDriverBreakModel extends ReviewDriverBreakEntity {
  constructor(dataDto: ReviewDriverBreakEntity) {
    super()
    mapEntityProperties<ReviewDriverBreakEntity>(this, dataDto, {
      map: {
        startAt: dataDto.startAt ? new Date(dataDto.startAt).toISOString() : undefined,
        endAt: dataDto.endAt ? new Date(dataDto.endAt).toISOString() : undefined
      }
    })
  }
}
